import React, { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./app.scss";
import ProtectedRoutes from "./Middleware/ProtectedRoutes";
import Loading from "./Components/Loading/Loading";
import "react-datepicker/dist/react-datepicker.css";
import HourlyProductionReport from "./Pages/HourlyProductionReport";

const Login = lazy(() => import("./Pages/Login"));
const ProductConsolidatedReport = lazy(() =>
  import("./Pages/ProductConsolidatedReport")
);
const SuborderSummary = lazy(() => import("./Pages/SuborderSummary"));
const SuborderLocalViewConsolidated = lazy(() =>
  import("./Pages/SuborderLocalViewConsolidated")
);
const TempHoldInventory = lazy(() => import("./Pages/TempHoldInventory"));
const TempHoldInventorySummary = lazy(() => import("./Pages/TempHoldSummary"));
const PortalNetInventorySummary = lazy(() =>
  import("./Pages/PortalNetInventorySummary")
);
const SalesAnalysis = lazy(() => import("./Pages/SalesAnalysis"));
const InventoryMissingList = lazy(() => import("./Pages/InventoryMissingList"));

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    element: <ProtectedRoutes />,
    children: [
      { path: "/", element: <ProductConsolidatedReport /> },
      {
        path: "/product-consolidated-report",
        element: <ProductConsolidatedReport />,
      },
      {
        path: "/hourly-production-report",
        element: <HourlyProductionReport />,
      },
      {
        path: "/suborder-summary",
        element: <SuborderSummary />,
      },
      {
        path: "/suborder-local-view-consolidated",
        element: <SuborderLocalViewConsolidated />,
      },
      {
        path: "/temp-hold-inventory/:id?",
        element: <TempHoldInventory />,
      },
      {
        path: "/temp-hold-inventory-summary",
        element: <TempHoldInventorySummary />,
      },
      {
        path: "/portal-net-inventory-summary",
        element: <PortalNetInventorySummary />,
      },
      {
        path: "/sales-analysis",
        element: <SalesAnalysis />,
      },
      {
        path: "/inventory-missing-list",
        element: <InventoryMissingList />,
      },
    ],
  },
]);

const App = () => {
  return (
    <Suspense
      fallback={
        <Loading color={"rgba(1, 18, 34, 1)"} size={42} height={true} />
      }
    >
      <RouterProvider
        router={router}
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      />
    </Suspense>
  );
};

export default App;